'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_Lmagnolia1_CaseClass$Param__toString__T($thiz) {
  return (("Param(" + $thiz.k7) + ")");
}
export { $f_Lmagnolia1_CaseClass$Param__toString__T as $f_Lmagnolia1_CaseClass$Param__toString__T };
var $d_Lmagnolia1_CaseClass$Param = new $j_java$002elang$002e$002dObject.$TypeData().i(1, "magnolia1.CaseClass$Param", ({
  e4: 1,
  a: 1
}));
export { $d_Lmagnolia1_CaseClass$Param as $d_Lmagnolia1_CaseClass$Param };
